export default function describeCoverage(value) {
    const numberValue = typeof value === 'number'
        ? value
        : parseInt(value, 10);

    switch (Math.round(numberValue)) {
        case 4:
            return "Excellent Coverage";
        case 3:
            return "Good Coverage";
        case 2:
            return "Some Coverage";
        case 1:
            return "Major Issues";
        case 0:
            return "No Service";
        default:
            return "";
    }
}
